module.exports = __webpack_public_path__ + "static/media/Icon-Yellow.104fa5cb.svg";